/**
 * @file documentPages.reducer.js
 * @description now there's not much happening here.
 *              there was a lot originally. perhaps tomorrow.
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Mar 09, 2022 15:22
 */
import * as Actions from 'src/store/actions/document/documentPages.actions';

const initialState = {
    // server status
    serverErrorExists: false,
    serverFieldErrors: {},  // field errors from the server, passed into the form for display
    serverMessage: '', // message from server for display in toaster message
};

const documentPagesReducer = (state = initialState, action) => {
    switch (action.type) {

        /************* */
        default: {
            return state;
        }
    }
}

export default documentPagesReducer;